/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.BuyingRpc
 */

/**
 *  Request model for purchasing products and quantity packs.
 *  <p><b>Products:</b> Use {@code products} for parent/bundle products (e.g., "marketing-hub-starter").
 *  <p><b>Quantity Packs:</b> Use {@code quantityPacks} with {@link RequestedQuantity}
 *  <pre>{@code
 *  PurchaseRequest request = PurchaseRequest.builder()
 *    .setQuantityPacks(ImmutableSet.of(
 *      RequestedQuantity.builder()
 *        .setQuantityName(WireSafeEnum.of(QuantityName.CONTACTS))
 *        .setTotalQuantity(10)
 *        .setParentProductApiName("marketing-hub-starter")
 *        .build()
 *    ))
 *    .build();
 *  }</pre>
 */

export let ComHubspotBuyingModelsRpcAbstractBuyingRpcError;
(function (_ComHubspotBuyingModelsRpcAbstractBuyingRpcError) {})(ComHubspotBuyingModelsRpcAbstractBuyingRpcError || (ComHubspotBuyingModelsRpcAbstractBuyingRpcError = {}));
export let ComHubspotBuyingModelsRpcEnums;
(function (_ComHubspotBuyingModelsRpcEnums) {})(ComHubspotBuyingModelsRpcEnums || (ComHubspotBuyingModelsRpcEnums = {}));
/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export const createPurchaseOrderRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'createPurchaseOrder',
  auth: 'app',
  fingerprint: '_XCnKSsip0TY5pstqgNqILbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createPurchaseOrderV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'createPurchaseOrderV2',
  auth: 'app',
  fingerprint: '0EcIdQuHpyrY5pstqgNqILbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatsProductInventoryRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getSeatsProductInventory',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACHTP33O5UJ5JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInterstitialRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getInterstitial',
  auth: 'app',
  fingerprint: '_XCnKSsip0Rb8KvTB1txtpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInterstitialV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getInterstitialV2',
  auth: 'app',
  fingerprint: '_XCnKSsip0Rb8KvTB1txtrJBp4StIrgH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePurchaseOrderRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'updatePurchaseOrder',
  auth: 'app',
  fingerprint: 'sAZBOvPxz4uiWV_cTkWl8LbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchUpgradeRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'fetchUpgrade',
  auth: 'app',
  fingerprint: 'C79PEdY59i8yKM6MrBCP9pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchQuantityChangeRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'fetchQuantityChange',
  auth: 'app',
  fingerprint: '0RB5RhgJHq3bTBEY_rEW6pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};